










import Vue from "vue";
import BreadCrumbs from "@/components/common/BreadCrumbs.vue";

export default Vue.extend({
  name: "page-title",
  props: {
    title: String,
    breadcrumbs: { type: Array, default: () => null },
  },
  components: {
    BreadCrumbs,
  },
});
